import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import HeroBand from '@/components/home/HeroBand';
import StatementBand from '@/components/home/StatementBand';
import MakingOfBand from '@/components/home/MakingOfBand';
import StudioBand from '@/components/home/StudioBand';
import NewsletterBand from '@/components/home/NewsletterBand';
import MemoryBand from '@/components/memory/MemoryBand';
import { DEFAULT_SETTINGS } from '@/config/defaults';

/**
 * Homepage — campaign era. Film-first hero, then full-width color-banded
 * sections, each composed like its own poster:
 * HERO → STATEMENT → MAKING-OF → STUDIO → NEWSLETTER.
 * Film-led palette: black / film-indigo / paper, with red as a surgical accent only.
 */

const Home = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Maximum Productions",
        "alternateName": "Max Prod",
        "url": "https://thisismaximum.com",
        "logo": "https://thisismaximum.com/favicon.svg",
        "description": "Maximum Productions — Animation studio. Currently in production on ETERNITY, a cyberpunk short film about immortality and loss. Coming 2028.",
        "sameAs": [
            DEFAULT_SETTINGS.socialYoutube,
            DEFAULT_SETTINGS.socialInstagram,
            DEFAULT_SETTINGS.socialTiktok,
            DEFAULT_SETTINGS.socialTwitter,
        ].filter(Boolean)
    };

    return (
        <div className="home-page">
            <SEO
                title="Maximum Productions | Animation Studio — ETERNITY Coming 2028"
                description="Maximum Productions — Animation studio. Currently in production on ETERNITY, a cyberpunk short film about immortality and loss. Coming 2028."
                schema={schema}
            />
            <Header />
            <main>
                <HeroBand />
                <StatementBand />
                <MakingOfBand />
                <StudioBand />
                <MemoryBand source="band-home" />
                <NewsletterBand />
            </main>
            <Footer />

            <style>{`
                .home-page {
                    /* Shared band rhythm — every band uses these. */
                    --bx: clamp(1.25rem, 5vw, 4rem);
                    --by: clamp(4.5rem, 11vw, 8.5rem);
                }
            `}</style>
        </div>
    );
};

export default Home;
